/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const dog_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#dog_medium_svg__a)">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M20.008 13.442c-.448 3.34-1.685 6.444-3.85 8.164M4.146 13.442c.447 3.34 1.685 6.444 3.85 8.164m4.08-3.75c1.224 0 2.216-.66 2.216-1.472 0-.812-.992-1.471-2.216-1.471-1.223 0-2.215.659-2.215 1.471 0 .813.992 1.472 2.215 1.472Zm0 0c-.693 1.38-2.336 3.75-4.08 3.75m4.08-3.75c.693 1.38 2.336 3.75 4.08 3.75M7.232 2.99c.104.352.114.736 0 1.125a28.889 28.889 0 0 1-2.335 5.647c-.534 1.014-2.04 1.032-2.598.032C1.327 8.076.395 5.637 1.5 3.8a4.86 4.86 0 0 1 3.093-2.378c1.16-.262 2.324.507 2.638 1.569Zm0 0c.694-.54 1.357-1.086 2.174-1.441a6.769 6.769 0 0 1 5.183-.067c.836.338 1.524.86 2.21 1.426m0 0a2 2 0 0 0-.03 1.207 28.884 28.884 0 0 0 2.334 5.647c.523.993 2.037 1.037 2.598.032.972-1.719 1.904-4.158.798-5.995-.747-1.377-2.549-2.831-4.21-2.343A2.284 2.284 0 0 0 16.8 2.91ZM7.997 21.606c2.341 1.859 5.82 1.859 8.16 0M8.823 10.005h.346m5.652 0h.346m-5.919 0c0 .183-.16.243-.248.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Zm5.998 0c0 .183-.16.243-.248.243-.091 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Z"
      />
    </g>
    <defs>
      <clipPath id="dog_medium_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default dog_medium
